import { FC, useState } from 'react';

import { Button, Card, Cell, CellText, Checkbox, Input, NumberInput, VSpacingContainer } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { updateUser } from 'components/Admin/UserDetail/EditUserForm/updateUser';
import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';

import { useDispatch } from 'store/utils';

interface EditUserFormProps {
    personalManagerId: number | null;
    personalManagerEmail: string;
    useHHManager: boolean;
}

const TrlKeys = {
    personalManagerIdPlaceholder: 'admin.UserDetail.EditUserForm.PersonalManagerId.placeholder',
    personalManagerIdHint: 'admin.UserDetail.EditUserForm.PersonalManagerId.hint',
    personalManagerIdLegend: 'admin.UserDetail.EditUserForm.PersonalManagerId.legend',
    personalManagerEmailPlaceholder: 'admin.UserDetail.EditUserForm.PersonalManagerEmail.placeholder',
    personalManagerEmailHint: 'admin.UserDetail.EditUserForm.PersonalManagerEmail.hint',
    personalManagerEmailLegend: 'admin.UserDetail.EditUserForm.PersonalManagerEmail.legend',
    useHHManager: 'admin.UserDetail.EditUserForm.UseHHManager',
    save: 'admin.UserDetail.EditUserForm.save',
};

export const EditUserForm: FC<EditUserFormProps> = ({ personalManagerId, personalManagerEmail, useHHManager }) => {
    const [isLoad, setLoad] = useState(false);
    const [userPersonalManagerId, setPersonalManagerId] = useState(`${personalManagerId || ''}`);
    const [userPersonalManagerEmail, setPersonalManagerEmail] = useState(personalManagerEmail);
    const [userUseHHManager, setUseHHManager] = useState(useHHManager);

    const dispatch = useDispatch();
    const trls = useTrls();

    const onClickSaveUser = () => {
        void dispatch(updateUser(setLoad, userPersonalManagerId, userPersonalManagerEmail, userUseHHManager));
    };

    return (
        <Card borderWidth="default" padding={20}>
            <VSpacingContainer default={24}>
                <MagritteFormField
                    label={trls(TrlKeys.personalManagerIdLegend)}
                    labelTooltipContent={trls(TrlKeys.personalManagerIdHint)}
                    input={
                        <NumberInput
                            value={userPersonalManagerId}
                            onChange={setPersonalManagerId}
                            placeholder={trls(TrlKeys.personalManagerIdPlaceholder)}
                            allowNegative={false}
                            decimalMark={[]}
                            decimalLength={0}
                            groupSize={Infinity}
                        />
                    }
                />
                <MagritteFormField
                    label={trls(TrlKeys.personalManagerEmailLegend)}
                    labelTooltipContent={trls(TrlKeys.personalManagerEmailHint)}
                    input={
                        <Input
                            value={userPersonalManagerEmail}
                            onChange={setPersonalManagerEmail}
                            placeholder={trls(TrlKeys.personalManagerEmailPlaceholder)}
                            data-qa="manager-email-input"
                        />
                    }
                />
                <Cell
                    width="fit-content"
                    left={
                        <Checkbox
                            checked={userUseHHManager}
                            onChange={(event) => setUseHHManager(event.target.checked)}
                        />
                    }
                >
                    <CellText>{trls(TrlKeys.useHHManager)}</CellText>
                </Cell>
                <Button
                    mode="primary"
                    style="accent"
                    loading={isLoad}
                    onClick={onClickSaveUser}
                    data-qa="save-users-settings"
                    size="medium"
                >
                    {trls(TrlKeys.save)}
                </Button>
            </VSpacingContainer>
        </Card>
    );
};
